export default "__VITE_ASSET__0bd052b7__"